import { Injectable } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";

export interface MetaTagsContent {
  name: string;
  content: string;
}

export type MetaNameType = 'title' | 'description' | 'keywords' | 'author' | 'viewport' | 'og:title' | 'og:description' | 'og:url' | 'og:image' | 'product:brand' | 'product:availability' | 'product:condition' | 'product:price:amount' | 'product:price:currency' | 'product:retailer_item_id' | 'product:item_group_id' | 'google-site-verification' | 'product:item_group_id';

@Injectable({
  providedIn: 'root',
})
export class MetaTagsService {
  constructor(
    private Meta: Meta,
    private Title: Title,
  ) {}

  private setTitle(content: string) {
    this.Title.setTitle(content);
  }

  set(list:{[key in MetaNameType]?: string}) {
    Object.keys(list).forEach((key) => {
      this.handleEach({name: key, content: list[key as MetaNameType] || ''});
    });
  }

  private handleEach(options:MetaTagsContent) {
    if (options.name === 'title') {
      this.setTitle(options.content);
    }
    else if (options.name.match(/\:/)) {
      this.Meta.updateTag({property: options.name, content: options.content})
    }
    else {
      this.Meta.updateTag({ name: options.name, content: options.content });
    }
  }

  remove(name:string) {
    if (name.match(/\:/)) {
      this.Meta.removeTag(`property="${name}"`);
    } else {
      this.Meta.removeTag(`name="${name}"`);
    }
  }
}